<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('index.dateControl')" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p df-c-ct">

          <div class="left df-l-fs ">

            <div class="mb20 lh30">
              <div class="_themecolor f-xs f-bold">{{$t('key.currentDate')}}</div>
              <div class="f-xs">{{currentDate}}</div>
            </div>

            <div class="day">
              <div class="_themecolor f-xs lh30">{{$t('key.editDate')}}</div>
              <div class="day-content df-w-c-sb">
                <div v-for="(x,i) in 7" :key="i" class="day-item df-c-fs" @click="indexAc=x">
                  <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="indexAc===x?iconCheckok2:iconChecknull2" />
                  <div class="day-label f-dark f-xs">{{$t('key.day'+x)}}</div>
                </div>
              </div>
            </div>

          </div>
          
          <div class="right f1 df-l-c-ct mt20 border">

            <div class="warning _themecolor f-s mb20 lh30 plr20">
              <span class="fsk0 f-xs f-bold">{{$t('key.editDateWarning1')}}</span>
              <span class="f-xs">{{$t('key.editDateWarning2')}}</span>
            </div>
            <InputCustom
              class="mb20"
              :inputable="true"
              :showPassword="true"
              inputWidth="263"
              :inputPlaceholder="$t('key.inputPsd')"
              :inputValue="password" />
            <Keyboard :inputValue.sync="password" />
          </div>

        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogDateControl',
  data() {
    return {
      isShowDialog: false,
      password: '',
      currentDate: '',
      indexAc: '',
    }
  },
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.dateHandler()
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.password = ''
      this.currentDate = ''
      this.indexAc = ''
    },
    async submit() {
      if (this.password) {
        let rD = { secondaryPassword: this.password }
        this.$api.password_verify(rD).then(async res => {
          if (res.status == 0) {
            const rD = {
              id: this.currentShopId,
              shopConfig: JSON.parse(JSON.stringify(this.shopConfig_m))
            }
            rD.shopConfig.controlDay = this.indexAc
            // console.log(`%crD:`, 'color: #f0f;', rD)
            const _D1 = await this.setData('shop', rD)
            if (_D1 === 'ok') {
              this.shop_x.shopConfig.controlDay = this.indexAc
              this.shop_x_save(this.shop_x)
              this.close()
            }
          } else { this._status(res) }
        })
      }
    },

    dateHandler() {
      const T = new Date()
      const DAYS = [
        {zh:'',en:''},
        {zh:'星期一',en:'Monday'},
        {zh:'星期二',en:'Tuesday'},
        {zh:'星期三',en:'Wednesday'},
        {zh:'星期四',en:'Thursday'},
        {zh:'星期五',en:'Friday'},
        {zh:'星期六',en:'Saturday'},
        {zh:'星期日',en:'Sunday'}
      ]
      if (this.lang === 'zh') {
        this.currentDate = this.$tool.time_parse_ymd(T, '/') + ' ' + DAYS[T.getDay()].zh
      } else if (this.lang === 'en') {
        const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December']
        const oYear = T.getFullYear()
        const oMonth = MONTHS[T.getMonth()]
        const oDay = T.getDate()
        this.currentDate = oMonth + ' ' + oDay + ' ' + oYear + ', ' + DAYS[T.getDay()].en
      }

      this.indexAc = this.shopConfig_m.controlDay || ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
/deep/.el-dialog{margin-top: 30px !important;}
.mydialog{
  padding: 30px 20px 0;box-sizing: border-box;
  .left{
    width: 366px;word-break: normal;
    .day{
      &-title{padding: 10px 0;}
      &-item{width: 50%;padding: 10px 0;box-sizing: border-box;}
    }
  }
  .right{
    .warning{word-break: normal;}
  }
  .border{border-left: 1px solid #979797;}
}
</style>